import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Alert, Card, CardContent, CircularProgress, Container, Stack, Typography } from '@mui/material';
import AppShellNav from '../../shell/AppShellNav';
import GoogleAuthButton from '../GoogleAuthButton';
import { googleApi, googleHeaders } from '../../utils/googleAuth';
import '../../shell/appShell.css';
export default function GoogleAccountPanel() {
  const location = useLocation();
  const [linked, setLinked] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    googleApi.get('/auth/google/link', googleHeaders()).then(({ data }) => setLinked(data.linked))
      .catch(e => setError(e.response?.data?.message || 'No se pudo consultar tu cuenta Google.'));
  }, []);
  return <div className="app-shell"><AppShellNav /><main className="app-shell-main">
    <Container maxWidth="sm" sx={{ py: 4 }}><Card><CardContent><Stack spacing={2}>
      <Typography variant="h4" component="h1">Cuenta Google</Typography>
      <Typography>Vincula Google a tu cuenta DevsSoft para iniciar sesión y acceder a tus herramientas con las suscripciones que ya tienes.</Typography>
      <Typography color="text.secondary">Los permisos del asistente se configuran por separado en Acceso MCP.</Typography>
      {location.state?.googleLinked && <Alert severity="success">Google vinculado. Ya puedes usar Continuar con Google para iniciar sesión.</Alert>}
      {error && <Alert severity="error">{error}</Alert>}
      {linked === null && !error && <CircularProgress aria-label="Consultando cuenta Google" />}
      {linked === true && <Alert severity="success">Tu cuenta Google está vinculada.</Alert>}
      {linked === false && <GoogleAuthButton purpose="link" returnTo="/account/google" onError={setError} />}
    </Stack></CardContent></Card></Container>
  </main></div>;
}
